const SwitchAll = {
    // 首页 ----------------------- start
    "db_ug": "dashboard_user_guide",                            // 新手引导
    "db_p": "dashboard_pagefly",                                // pagefly广告 banner
    "db_gw": "dashboard_googleScore_warn",                      // 右侧谷歌分数警告banner
    "db_gs": "dashboard_googleScore_success",                   // 右侧谷歌分数成功banner
    "db_af": "dashboard_affiliate",                             // Affiliate推广banner
    "db_adver": "dashboard_adver",                              // app广告列表
    "db_newfunc": "newFuncNums",                                // 新功能数量
    "db_imgquota": "dashboard_imgQuota",                        // 图片额度获取成功弹窗

    // onpage  ----------------------- start
    "op_dt": "onpage_detail_tip",                               // 详情页的tip banner

    // HTML Sitemap  ----------------------- start
    "html_rb": "html_removebrand",                              // 免费删除商标 banner

    // 外链互换  ----------------------- start
    "exchange_tb": "exchange_tip_banner",                       // 提示banner
    "exchange_upTip": "exchange_upgrade_tip",                       // 升级提示banner

    // 关键词research ----------------------- start
    "kw_issue": "keywords_issue",                               // 关键词research 问题banner

    // 谷歌Console ----------------------- start
    "gg_issue": "google_issue",                                 // 谷歌 问题banner

    // 及时索引  ----------------------- start
    "ii_useTop": "instant_index_top",                           // 及时索引指导模块
}

export default SwitchAll;